import { render } from "./MentalTestView.vue?vue&type=template&id=b618bdec&scoped=true"
import script from "./MentalTestView.vue?vue&type=script&lang=js"
export * from "./MentalTestView.vue?vue&type=script&lang=js"

import "./MentalTestView.vue?vue&type=style&index=0&id=b618bdec&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b618bdec"]])

export default __exports__